import { tokens } from "@utils/tokens";

/**
 * Brand-accent palette for the shared UI design system. Only MODE-INDEPENDENT
 * brand colours live here (referencing canonical tokens.ts). Semantic
 * text / surface / border colours come from the MUI theme palette inside each
 * component (theme-aware: text.primary, text.secondary, divider, error.main),
 * so the redesigned pages adapt to BOTH light and dark mode.
 */
export const surface = {
  primary: tokens.brandBlue,
  success: tokens.brandGreen,
  info: tokens.infoSky,
  warning: tokens.warning,
} as const;

export const radii = { card: 12, control: 8 } as const;
